import { useState } from 'react';
import { toast } from 'react-toastify';
import userService from 'services/user';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import styles from 'assets/styles/modal.module.scss';
import { ErrorResponse } from 'interfaces/global.types';
import { Box, Button, Typography } from '@mui/material';
import { shallowEqual, useSelector } from 'react-redux';
import { useUserDetails } from 'services/query/user/use-user-details';
import { Loading, CustomInput, LoadingButton, CustomModal, CustomInputPassword } from 'components';

type Props = {
  open: any;
  close: () => void;
};

export function Profil({ open, close }: Props) {
  const [active, setActive] = useState(false);
  const togglePwd = () => setShowPassword(!showPassword);
  const [showPassword, setShowPassword] = useState(false);
  const { user } = useSelector((state: any) => state.auth, shallowEqual);

  const {
    watch,
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { isLoading } = useUserDetails(user?.user_id, setValue);

  const onSuccessActions = () => {
    close();
  };

  const { isLoading: addLoad, mutate } = useMutation({
    mutationFn: (data: any) => userService.update(user?.user_id, data),
    onSuccess: (res: any) => {
      if (watch().password) {
        userService
          .updatePassword({
            user_id: res.id,
            password: watch().password,
          })
          .then(() => {
            if (onSuccessActions) onSuccessActions();
            toast.success(`Успешно обновлено!`);
          });
      } else {
        onSuccessActions();
        toast.success(`Успешно обновлено!`);
      }
    },
    onError: (error: ErrorResponse) => {
      toast.error(error?.data?.detail);
    },
  });

  const formSubmit = (data: any) => {
    mutate({
      email: data.email,
      username: data.username,
    });
  };

  return (
    <CustomModal open={open} close={close}>
      <form onSubmit={handleSubmit(formSubmit)} className={styles.modal}>
        <Box className={styles.titleCont}>
          <Typography className={styles.title} variant='h3' align='center'>
            {active ? 'Просмотр пользователя' : 'Редактировать пользователя'}
          </Typography>
        </Box>

        {isLoading ? (
          <Loading />
        ) : (
          <Box className={styles.content}>
            <Box mt='15px'>
              <CustomInput error={errors} name='username' control={control} label='Ф.И.О:' />
            </Box>

            <Box mt='15px'>
              <CustomInput error={errors} name={'email'} control={control} label='Логин:' />
            </Box>

            {!active ? (
              <Button className={styles.editPass} onClick={() => setActive(true)}>
                Изменить пароль
              </Button>
            ) : (
              <Box mt='15px'>
                <CustomInputPassword
                  error={errors}
                  control={control}
                  name='password'
                  label='Пароль:'
                  disabled={!active}
                  showPassword={showPassword}
                  togglePwd={togglePwd}
                />
              </Box>
            )}
          </Box>
        )}

        <Box className={styles.modalFooter}>
          <Box width='100%' display='flex' gap='15px'>
            <LoadingButton variant='cancel' onClick={close}>
              Отменить
            </LoadingButton>
            <LoadingButton loading={addLoad} type='submit' variant='send'>
              Подтвердить
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </CustomModal>
  );
}
